<form [formGroup]="quizForm" *ngIf="quizForm">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">Edit IT Profiles</h3>
    <p-select
      *ngIf="quiz"
      [options]="itProfiles"
      optionLabel="name"
      optionValue="clientITProfileId"
      [(ngModel)]="quiz.clientITProfileId"
      (onChange)="onItProfileChanged($event)"
      [ngModelOptions]="{standalone: true}"
    >
    </p-select>
    <div class="flex align-items-center">
      <p-button
        [text]="true"
        pTooltip="Create New"
        icon="pi pi-plus"
        (click)="createItProfile()"
      ></p-button>
      <p-button
        *ngIf="quiz"
        [text]="true"
        icon="pi pi-copy"
        pTooltip="Clone"
        (click)="copyItProfile(quiz)"
      ></p-button>
      <p-button
        *ngIf="quiz"
        [text]="true"
        pTooltip="Fill Data"
        icon="pi pi-list"
        [routerLink]="['/profiles', 'itProfile', quiz.clientITProfileId]"
      ></p-button>
      <p-button
        *ngIf="quiz"
        [text]="true"
        icon="pi pi-trash"
        severity="danger"
        mwlConfirmationPopover
        [title]="'Delete Selected IT Profile'"
        [popoverMessage]="
              'You are going to delete selected IT Profile. Are you sure?'
            "
        [appendToBody]="true"
        [confirmText]="'Yes'"
        [cancelText]="'No'"
        placement="bottom"
        (confirm)="removeItProfile()"
      ></p-button>
      <p-button
        *ngIf="quiz && returnToProjectId"
        [text]="true"
        icon="pi pi-briefcase"
        [routerLink]="['/projects/project', returnToProjectId]"
      ></p-button>
    </div>
    <div style="display: flex; flex-direction: row;" *ngIf="quizForm">
      <mat-form-field style="width: 50%">
        <mat-label>Name</mat-label>
        <input matInput name="name" formControlName="name" required/>
      </mat-form-field>
      <mat-form-field style="margin: 0 20px">
        <mat-label>Authors</mat-label>
        <mat-select
          formControlName="ownerList"
          name="ownerList"
          multiple>
          <mat-option *ngFor="let user of users" [value]="user">
            {{ getFullName(user) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <p-button
      [text]="true"
      icon="pi pi-save"
      (click)="send()"
      *ngIf="quiz"
    ></p-button>
  </div>
  <div class="training-component" *ngIf="quiz && quiz.quizData">
    <div style="margin-left: 20px;">
      <mat-horizontal-stepper [linear]="false" #stepper *ngIf="quiz?.quizData?.steps">

        <mat-step [stepControl]="{invalid: false}"
                  style="margin-bottom: 10px">
          <ng-template matStepLabel>
            Devices
          </ng-template>

          <p style="font-size:16px;"><strong>OT Devices Fields</strong></p>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Device Name Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameDeviceName"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isDeviceNameVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Type Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameType"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isTypeVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Manufacturer Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameManufacturer"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isManufacturerVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Model Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameModel"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isModelVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Serial Number Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameSerialNumber"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isSerialNumberVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>IP Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameIP"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isIPVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>MAC Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameMAC"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isMACVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>PUID Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNamePUID"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isPUIDVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Owner Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameOwner"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isOwnerVisible">Visible</mat-checkbox>
          </div>
          <div style="display: flex; flex-direction: row;">
            <mat-form-field class="example-full-width">
              <mat-label>Location Field</mat-label>
              <input matInput
                     formControlName="deviceFieldNameLocation"
                     required>
              <mat-error>This field is required</mat-error>
            </mat-form-field>
            <mat-checkbox formControlName="isLocationVisible">Visible</mat-checkbox>
          </div>
          <div>
            <button mat-raised-button
                    matStepperNext
                    type="button">
              Next
            </button>
            <button mat-raised-button (click)="send()">Save</button>
          </div>
        </mat-step>

        <mat-step *ngFor="let step of quiz.quizData.steps; let i = index"
                  [stepControl]="{invalid: i == quiz.quizData.steps.length - 1}">
          <ng-template matStepLabel>
            <mat-form-field>
              <mat-label>Section Name</mat-label>
              <input matInput name="name" required
                     [(ngModel)]="step.name" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <div class="fa fa-arrow-left" *ngIf="i > 0" (click)="moveUp(quiz.quizData.steps, i)"></div>
            <div class="fa fa-arrow-right" *ngIf="i < (quiz.quizData.steps.length - 1)"
                 (click)="moveDown(quiz.quizData.steps, i)"></div>
            <div class="icon-delete-small" (click)="removeStep(i)"></div>
          </ng-template>
          <ng-template matStepperIcon></ng-template>
          <div *ngFor="let item of step.items;let q = index" class="item" style="margin-top: 10px">
            <div style="display: flex; flex-direction: row;">
              <div style="flex:0 0 50px">
                <div class="fa fa-arrow-up" *ngIf="q > 0" (click)="moveUp(step.items, q)"></div>
                <div class="fa fa-arrow-down" *ngIf="q < step.items.length - 1"
                     (click)="moveDown(step.items, q)"></div>
              </div>
              <div style="flex:1 1 calc(100% - 100px)">
                <ng-container *ngIf="item.type == 'question'">
                  <div style="display: flex; flex-direction: row;">
                    <mat-form-field style="width: 100%; flex:1 1 auto">
                      <mat-label>Question</mat-label>
                      <input matInput name="name" [(ngModel)]="item.name" [ngModelOptions]="{standalone: true}">
                    </mat-form-field>
                  </div>
                  <div style="margin-left: 10px;" *ngIf="!item.multiple">
                    <mat-radio-group [name]="'r' + i + '_' + q" [(ngModel)]="item.correctAnswer" [ngModelOptions]="{standalone: true}">
                      <div *ngFor="let a of item.answers;let h = index">
                        <div style="display: flex; flex-direction: row;">
                          <div style="flex:0 0 50px">
                            <mat-radio-button [value]="h" [name]="'r' + i + '_' + q">
                              {{ 'ABCDEFGHIJKL'[h] }}.
                            </mat-radio-button>
                          </div>
                          <div style="flex:1 1 auto">
                            <mat-form-field style="width: 100%">
                              <mat-label>Answer</mat-label>
                              <input matInput name="name" [(ngModel)]="a.name" [ngModelOptions]="{standalone: true}">
                            </mat-form-field>
                          </div>
                          <div style="flex:0 0 50px">
                            <div class="icon-delete-small" (click)="item.answers.splice(h, 1)"></div>
                          </div>
                        </div>
                        <button mat-raised-button (click)="addControlItem(a.controlItems)" style="margin: 10px 0">
                          Recommend Controls
                        </button>
                        <p-table *ngIf="a.controlItems?.length"
                                 [value]="a.controlItems"
                                 [ngStyle]="{margin: '0 0 10px 0', display: 'block'}">

                          <ng-template pTemplate="header">
                            <tr style="white-space: nowrap;font-weight: bold">
                              <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                                {{ col.header }}
                              </th>
                              <th style="width:15em"></th>
                            </tr>
                          </ng-template>

                          <ng-template pTemplate="body" let-item>
                            <tr [pSelectableRow]="item">
                              <td *ngFor="let col of cols">{{ item[col.field] }}</td>
                              <td>
                                <button type="button"
                                        pButton
                                        class="risksponge-button"
                                        (click)="removeControlItem(a.controlItems, item)"
                                        icon="pi pi-trash">
                                </button>
                              </td>
                            </tr>
                          </ng-template>

                        </p-table>
                      </div>
                    </mat-radio-group>
                    <button mat-raised-button (click)="addAnswer(item.answers)">Add Answer</button>
                    <button mat-raised-button (click)="item.multiple = true">Change to Checkboxes</button>
                  </div>
                  <div style="margin-left: 10px;" *ngIf="item.multiple">
                    <div *ngFor="let a of item.answers;let h = index">
                      <div style="display: flex; flex-direction: row;">
                        <div style="flex:0 0 50px">
                          <mat-checkbox>{{ 'ABCDEFGHIJKL'[h] }}.</mat-checkbox>
                        </div>
                        <div style="flex:1 1 auto">
                          <mat-form-field style="width: 100%">
                            <mat-label>Answer</mat-label>
                            <input matInput name="name" [(ngModel)]="a.name" [ngModelOptions]="{standalone: true}">
                          </mat-form-field>
                        </div>
                        <div style="flex:0 0 50px">
                          <div class="icon-delete-small" (click)="item.answers.splice(h, 1)"></div>
                        </div>
                      </div>
                      <button mat-raised-button (click)="addControlItem(a.controlItems)" style="margin: 10px 0">
                        Recommend Controls
                      </button>
                      <p-table *ngIf="a.controlItems.length"
                               [value]="a.controlItems"
                               [ngStyle]="{margin: '0 0 10px 0', display: 'block'}">

                        <ng-template pTemplate="header">
                          <tr style="white-space: nowrap;font-weight: bold">
                            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
                              {{ col.header }}
                            </th>
                            <th style="width:15em"></th>
                          </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-item>
                          <tr [pSelectableRow]="item">
                            <td *ngFor="let col of cols">{{ item[col.field] }}</td>
                            <td>
                              <button type="button"
                                      pButton
                                      class="risksponge-button"
                                      (click)="removeControlItem(a.controlItems, item)"
                                      icon="pi pi-trash">
                              </button>
                            </td>
                          </tr>
                        </ng-template>

                      </p-table>
                    </div>
                    <button mat-raised-button (click)="addAnswer(item.answers)">Add Answer</button>
                    <button mat-raised-button (click)="item.multiple = false">Change to Radio-buttons</button>
                  </div>
                </ng-container>
              </div>
              <div style="flex:0 0 50px">
                <div class="icon-delete-small" (click)="step.items.splice(q, 1)"></div>
              </div>
            </div>
          </div>
          <div style="margin-top: 20px;" class="controls">
            <button mat-raised-button (click)="addQuestion(step.items)">Add Question</button>
            <button mat-raised-button (click)="send()">Save</button>
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>
            <div class="fa fa-plus" (click)="addStep()"></div>
          </ng-template>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</form>
